export interface ActiveSubscriptionResponse {
  success: boolean;
  hasActiveSubscription: boolean;
  subscription?: {
    platform: "STRIPE" | "APPLE" | "GOOGLE";
    subscription: string; // 'standard', 'premium', etc.
    expirationDate: string; // ISO date string
    purchaseDate: string; // ISO date string
  } | null;
  message?: string;
}

/**
 * Get user's active subscription information
 *
 * @param accessAuth0Token - Auth0 access token
 * @returns Response with subscription details including expiration date
 */
export const getActiveSubscription = async (accessAuth0Token: string): Promise<ActiveSubscriptionResponse> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/payments/active-subscription`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuth0Token}`,
      },
      credentials: "include",
    });

    const data = (await response.json()) as ActiveSubscriptionResponse;
    if (!response.ok) {
      return {
        success: false,
        hasActiveSubscription: false,
        message: data?.message || "Failed to get subscription information",
      };
    }
    return data;
  } catch (error) {
    console.error("getActiveSubscription error:", error);
    return {
      success: false,
      hasActiveSubscription: false,
      message: "Network error. Please check your connection and try again.",
    };
  }
};
